const DAY_MS = 86400000

export const HRT_REQUIRED_BIOMARKERS = [
  { label: 'Total testosterone', aliases: ['total testosterone', 'testosterone total', 'testosterone, total', 'testosterone total males', 'testosterone, total, males'] },
  { label: 'Free testosterone', aliases: ['free testosterone', 'testosterone free', 'testosterone, free', 'calc free testosterone', 'calculated free testosterone'] },
  { label: 'SHBG', aliases: ['shbg', 'sex hormone binding globulin', 'sex horm bind globulin', 'sex hormone bind globulin'] },
  { label: 'Estradiol', aliases: ['estradiol', 'estradiol sensitive', 'estradiol ultrasensitive', 'e2'] },
  { label: 'LH', aliases: ['lh', 'luteinizing hormone'] },
  { label: 'FSH', aliases: ['fsh', 'follicle stimulating hormone'] },
  { label: 'Prolactin', aliases: ['prolactin'] },
  { label: 'CBC / hematocrit', aliases: ['cbc', 'complete blood count', 'hematocrit', 'hct', 'hemoglobin and hematocrit'] },
  { label: 'CMP', aliases: ['cmp', 'comprehensive metabolic panel', 'metabolic panel'] },
  { label: 'Lipid panel', aliases: ['lipid panel', 'cholesterol', 'hdl', 'ldl', 'triglycerides'] },
  { label: 'HbA1c', aliases: ['hba1c', 'hemoglobin a1c', 'a1c'] },
  { label: 'TSH / free T4', aliases: ['tsh', 'free t4', 't4 free', 'thyroxine free'] },
]

export const HRT_PSA_BIOMARKER = {
  label: 'PSA, age 40+',
  aliases: ['psa', 'psa total', 'prostate specific antigen', 'prostate-specific antigen'],
}

const ACCESS_FUNCTIONAL_HEALTH_PLUS_BIOMARKERS = [
  { label: 'ANA Screen', aliases: ['ana screen', 'antinuclear antibody'] },
  { label: 'White blood cells', aliases: ['white blood cells', 'white blood cell count', 'wbc'] },
  { label: 'Red blood cells', aliases: ['red blood cells', 'red blood cell count', 'rbc'] },
  { label: 'Hemoglobin', aliases: ['hemoglobin', 'hgb'] },
  { label: 'Hematocrit', aliases: ['hematocrit', 'hct'] },
  { label: 'MCV', aliases: ['mcv', 'mean corpuscular volume'] },
  { label: 'MCH', aliases: ['mch', 'mean corpuscular hemoglobin'] },
  { label: 'MCHC', aliases: ['mchc'] },
  { label: 'RDW', aliases: ['rdw', 'red cell distribution width'] },
  { label: 'Platelets', aliases: ['platelets', 'platelet count'] },
  { label: 'Neutrophils', aliases: ['neutrophils', 'absolute neutrophils', 'neutrophils absolute'] },
  { label: 'Lymphocytes', aliases: ['lymphocytes', 'absolute lymphocytes', 'lymphocytes absolute'] },
  { label: 'Monocytes', aliases: ['monocytes', 'absolute monocytes', 'monocytes absolute'] },
  { label: 'Eosinophils', aliases: ['eosinophils', 'absolute eosinophils', 'eosinophils absolute'] },
  { label: 'Basophils', aliases: ['basophils', 'absolute basophils', 'basophils absolute'] },
  { label: 'CEA', aliases: ['cea', 'carcinoembryonic antigen'] },
  { label: 'Glucose', aliases: ['glucose', 'fasting glucose'] },
  { label: 'BUN', aliases: ['bun', 'urea nitrogen', 'blood urea nitrogen'] },
  { label: 'Creatinine', aliases: ['creatinine'] },
  { label: 'eGFR', aliases: ['egfr', 'estimated glomerular filtration rate'] },
  { label: 'BUN/Creatinine ratio', aliases: ['bun creatinine ratio', 'bun/creatinine ratio'] },
  { label: 'Sodium', aliases: ['sodium'] },
  { label: 'Potassium', aliases: ['potassium'] },
  { label: 'Chloride', aliases: ['chloride'] },
  { label: 'Carbon dioxide', aliases: ['carbon dioxide', 'co2', 'bicarbonate'] },
  { label: 'Calcium', aliases: ['calcium'] },
  { label: 'Protein, total', aliases: ['protein total', 'total protein'] },
  { label: 'Albumin', aliases: ['albumin'] },
  { label: 'Globulin', aliases: ['globulin'] },
  { label: 'Albumin/Globulin ratio', aliases: ['albumin globulin ratio', 'a/g ratio', 'ag ratio'] },
  { label: 'Bilirubin, total', aliases: ['bilirubin total', 'total bilirubin'] },
  { label: 'Alkaline phosphatase', aliases: ['alkaline phosphatase', 'alk phos', 'alp'] },
  { label: 'AST', aliases: ['ast', 'aspartate aminotransferase', 'sgot'] },
  { label: 'ALT', aliases: ['alt', 'alanine aminotransferase', 'sgpt'] },
  { label: 'Cortisol', aliases: ['cortisol'] },
  { label: 'CK, total', aliases: ['ck total', 'creatine kinase total', 'creatine kinase'] },
  { label: 'hs-CRP', aliases: ['hs crp', 'hs-crp', 'high sensitivity crp', 'high-sensitivity crp'] },
  { label: 'DHEA-S', aliases: ['dhea sulfate', 'dhea-s', 'dheas', 'dhea sulfate serum'] },
  { label: 'DHT', aliases: ['dht', 'dihydrotestosterone'] },
  { label: 'Estradiol', aliases: ['estradiol', 'e2', 'estradiol sensitive', 'estradiol ultrasensitive'] },
  { label: 'Ferritin', aliases: ['ferritin'] },
  { label: 'Folate', aliases: ['folate', 'folic acid'] },
  { label: 'FSH', aliases: ['fsh', 'follicle stimulating hormone'] },
  { label: 'Hemoglobin A1c', aliases: ['hemoglobin a1c', 'hba1c', 'a1c'] },
  { label: 'Homocysteine', aliases: ['homocysteine'] },
  { label: 'IGF-1', aliases: ['igf 1', 'igf-1', 'insulin-like growth factor 1', 'insulin like growth factor 1'] },
  { label: 'Iodine', aliases: ['iodine', 'iodine serum', 'iodine plasma'] },
  { label: 'TIBC', aliases: ['tibc', 'total iron binding capacity', 'iron binding capacity total'] },
  { label: 'LH', aliases: ['lh', 'luteinizing hormone'] },
  { label: 'Cholesterol, total', aliases: ['cholesterol total', 'total cholesterol'] },
  { label: 'HDL cholesterol', aliases: ['hdl cholesterol', 'hdl'] },
  { label: 'LDL cholesterol', aliases: ['ldl cholesterol', 'ldl'] },
  { label: 'VLDL cholesterol', aliases: ['vldl cholesterol', 'vldl'] },
  { label: 'Non-HDL cholesterol', aliases: ['non hdl cholesterol', 'non-hdl cholesterol'] },
  { label: 'Triglycerides', aliases: ['triglycerides'] },
  { label: 'Cholesterol/HDL ratio', aliases: ['cholesterol hdl ratio', 'chol/hdl ratio', 'cholesterol/hdl ratio'] },
  { label: 'Lipoprotein(a)', aliases: ['lipoprotein a', 'lipoprotein(a)', 'lp(a)', 'lpa'] },
  { label: 'Magnesium', aliases: ['magnesium', 'magnesium rbc', 'rbc magnesium'] },
  { label: 'Lp-PLA2', aliases: ['lp pla2', 'lp-pla2', 'plac test', 'plac test lp pla2'] },
  { label: 'Pregnenolone', aliases: ['pregnenolone'] },
  { label: 'Progesterone', aliases: ['progesterone'] },
  { label: 'TSH', aliases: ['tsh', 'thyroid stimulating hormone'] },
  { label: 'Free T4', aliases: ['free t4', 't4 free', 'thyroxine free'] },
  { label: 'Free T3', aliases: ['free t3', 't3 free', 'triiodothyronine free'] },
  { label: 'Thyroglobulin antibody', aliases: ['thyroglobulin antibody', 'tg antibody', 'tg ab'] },
  { label: 'Thyroid peroxidase antibody', aliases: ['thyroid peroxidase antibody', 'tpo antibody', 'tpo ab'] },
  { label: 'Reverse T3', aliases: ['reverse t3', 'rt3'] },
  { label: 'Sedimentation rate', aliases: ['sedimentation rate', 'sed rate', 'esr'] },
  { label: 'Total testosterone', aliases: ['total testosterone', 'testosterone total', 'testosterone, total', 'testosterone'] },
  { label: 'Free testosterone', aliases: ['free testosterone', 'testosterone free', 'testosterone, free', 'calc free testosterone', 'calculated free testosterone'] },
  { label: 'Bioavailable testosterone', aliases: ['bioavailable testosterone', 'testosterone bioavailable', 'calc bioavailable testosterone'] },
  { label: 'SHBG', aliases: ['shbg', 'sex hormone binding globulin', 'sex horm bind globulin', 'sex hormone bind globulin'] },
  { label: 'Uric acid', aliases: ['uric acid'] },
  { label: 'Vitamin B12', aliases: ['vitamin b12', 'b12', 'cobalamin'] },
  { label: 'Vitamin D', aliases: ['vitamin d', '25 hydroxyvitamin d', '25-hydroxyvitamin d', 'vitamin d 25-oh', '25 oh vitamin d'] },
  { label: 'Zinc', aliases: ['zinc', 'zinc rbc', 'rbc zinc'] },
]

const OPTIMAL_RANGE_RULES = [
  { aliases: ['hemoglobin a1c', 'hba1c', 'a1c'], max: 5.3 },
  { aliases: ['glucose', 'fasting glucose'], min: 75, max: 90 },
  { aliases: ['insulin', 'fasting insulin'], min: 2, max: 8 },
  { aliases: ['triglycerides'], max: 100 },
  { aliases: ['hdl', 'hdl cholesterol'], min: 50 },
  { aliases: ['ldl', 'ldl cholesterol'], max: 100 },
  { aliases: ['apob', 'apo b', 'apolipoprotein b'], max: 80 },
  { aliases: ['hs crp', 'hs-crp', 'crp', 'c reactive protein', 'c-reactive protein'], max: 1 },
  { aliases: ['vitamin d', '25 hydroxyvitamin d', '25-hydroxyvitamin d'], min: 50, max: 80 },
  { aliases: ['ferritin'], min: 50, max: 150 },
  { aliases: ['tsh', 'thyroid stimulating hormone'], min: 0.8, max: 2.5 },
  { aliases: ['total testosterone', 'testosterone total', 'testosterone, total'], min: 500, max: 900 },
  { aliases: ['free testosterone', 'testosterone free', 'testosterone, free', 'calc free testosterone', 'calculated free testosterone'], min: 12, max: 25 },
  { aliases: ['shbg', 'sex hormone binding globulin', 'sex horm bind globulin', 'sex hormone bind globulin'], min: 20, max: 50 },
  { aliases: ['estradiol', 'e2'], min: 20, max: 40 },
  { aliases: ['wbc', 'white blood cell', 'white blood cells', 'white blood cell count'], min: 4.5, max: 7 },
  { aliases: ['alt', 'alanine aminotransferase', 'sgpt'], max: 25 },
  { aliases: ['ast', 'aspartate aminotransferase', 'sgot'], max: 25 },
  { aliases: ['creatinine'], min: 0.7, max: 1.1 },
  { aliases: ['egfr', 'estimated gfr', 'estimated glomerular filtration rate'], min: 90, max: 120 },
  { aliases: ['bun', 'urea nitrogen', 'blood urea nitrogen'], min: 10, max: 20 },
]

const STATUS_RANGE_RULES = [
  { aliases: ['wbc', 'white blood cell', 'white blood cells', 'white blood cell count'], min: 4, max: 10.8 },
  { aliases: ['alt', 'alanine aminotransferase', 'sgpt'], max: 40 },
  { aliases: ['ast', 'aspartate aminotransferase', 'sgot'], max: 40 },
  { aliases: ['creatinine'], min: 0.6, max: 1.3 },
  { aliases: ['egfr', 'estimated gfr', 'estimated glomerular filtration rate'], min: 60, max: 130 },
  { aliases: ['bun', 'urea nitrogen', 'blood urea nitrogen'], min: 7, max: 25 },
]

export function normalizeBiomarkerName(value) {
  return String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
}

export function isLabReportSectionHeading(value) {
  const normalized = normalizeBiomarkerName(value)
  return /^access(?: labs?)? .+ biomarkers$/.test(normalized)
}

function normalizedMarkerAliases(marker = {}) {
  return [marker.label, ...(marker.aliases || [])]
    .map(normalizeBiomarkerName)
    .filter(Boolean)
}

function accessFunctionalHealthPlusMatch(key) {
  const normalizedKey = normalizeBiomarkerName(key)
  if (!normalizedKey) return null
  let best = null

  ACCESS_FUNCTIONAL_HEALTH_PLUS_BIOMARKERS.forEach((marker, index) => {
    normalizedMarkerAliases(marker).forEach(alias => {
      if (normalizedKey !== alias && !normalizedKey.includes(alias)) return
      const score = normalizedKey === alias ? 10000 + alias.length : alias.length
      if (!best || score > best.score || (score === best.score && index < best.index)) {
        best = { index, label: marker.label, score }
      }
    })
  })

  return best
}

function biomarkerRowMeta(key, fallbackName) {
  const accessMatch = accessFunctionalHealthPlusMatch(key)
  if (accessMatch) {
    return {
      section: 'access-functional-health-plus',
      sectionLabel: 'Access Functional Health Plus biomarkers',
      sectionOrder: 0,
      sortOrder: accessMatch.index,
      name: accessMatch.label,
    }
  }
  return {
    section: 'additional',
    sectionLabel: 'Additional biomarkers',
    sectionOrder: 1,
    sortOrder: Number.MAX_SAFE_INTEGER,
    name: fallbackName,
  }
}

function parseLocalDate(value) {
  if (!value) return null
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value
  const text = String(value).trim()
  const dateOnly = text.match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (dateOnly) {
    const date = new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
    return Number.isNaN(date.getTime()) ? null : date
  }
  const date = new Date(text)
  return Number.isNaN(date.getTime()) ? null : date
}

function dateInputValue(value) {
  const date = parseLocalDate(value)
  if (!date) return null
  return [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0'),
  ].join('-')
}

function normalizeCollectionDate(value) {
  const dateOnly = dateInputValue(value)
  if (!dateOnly) return null
  const date = parseLocalDate(dateOnly)
  const today = parseLocalDate(dateInputValue(new Date()))
  const oldest = new Date(today.getFullYear() - 10, today.getMonth(), today.getDate())
  if (date > today || date < oldest) return null
  return dateOnly
}

function normalizeDateParts(month, day, year) {
  const normalizedYear = Number(year) < 100
    ? Number(year) >= 70 ? 1900 + Number(year) : 2000 + Number(year)
    : Number(year)
  const date = new Date(normalizedYear, Number(month) - 1, Number(day))
  if (
    Number.isNaN(date.getTime()) ||
    date.getFullYear() !== normalizedYear ||
    date.getMonth() !== Number(month) - 1 ||
    date.getDate() !== Number(day)
  ) {
    return null
  }
  return normalizeCollectionDate(date)
}

function collectionDateFromText(value) {
  const text = String(value || '')
  if (!text) return null

  const iso = text.match(/\b(20\d{2})[-_/.](0?[1-9]|1[0-2])[-_/.](0?[1-9]|[12]\d|3[01])\b/)
  if (iso) return normalizeDateParts(iso[2], iso[3], iso[1])

  const monthDayYear = [...text.matchAll(/\b(0?[1-9]|1[0-2])[-_/.](0?[1-9]|[12]\d|3[01])[-_/.](\d{2}|\d{4})\b/g)]
  for (const match of monthDayYear) {
    const normalized = normalizeDateParts(match[1], match[2], match[3])
    if (normalized) return normalized
  }
  return null
}

function labDateStrings(order = {}) {
  return [
    order?.fileName,
    order?.filename,
    order?.lab,
    order?.lab_company,
    order?.title,
    order?.display_name,
    order?.displayName,
    order?.metadata?.fileName,
    order?.metadata?.filename,
    order?.metadata?.originalName,
    order?.metadata?.display_name,
    order?.metadata?.displayName,
    order?.document?.display_name,
    order?.pdf_document?.display_name,
    order?.requisition_document?.display_name,
    ...(Array.isArray(order?.lab_results) ? order.lab_results : []).flatMap(result => [
      result?.display_name,
      result?.document?.display_name,
    ]),
  ].filter(Boolean)
}

export function labCollectionDate(order = {}) {
  const explicit = [
    order?.collected_at,
    order?.collectedAt,
    order?.collection_date,
    order?.collectionDate,
    order?.specimen_collected_at,
    order?.specimenCollectedAt,
    order?.sample_collected_at,
    order?.sampleCollectedAt,
    order?.draw_date,
    order?.drawDate,
    order?.metadata?.collected_at,
    order?.metadata?.collectedAt,
    order?.metadata?.collection_date,
    order?.metadata?.collectionDate,
    order?.metadata?.specimen_collected_at,
    order?.metadata?.specimenCollectedAt,
    order?.metadata?.sample_collected_at,
    order?.metadata?.sampleCollectedAt,
    order?.metadata?.draw_date,
    order?.metadata?.drawDate,
    order?.test_date,
  ].map(normalizeCollectionDate).find(Boolean)
  if (explicit) return explicit
  return labDateStrings(order).map(collectionDateFromText).find(Boolean) || null
}

export function labReferenceDate(order = {}) {
  return labCollectionDate(order) ||
    dateInputValue(order?.latest_result_received_at) ||
    dateInputValue(order?.created_at) ||
    dateInputValue(order?.createdAt) ||
    null
}

export function labTitle(order = {}) {
  return order?.lab || order?.lab_company || order?.fileName || order?.display_name || 'Lab document'
}

function biomarkerName(value) {
  if (!value) return null
  if (typeof value === 'string') return value
  return value.name ||
    value.marker ||
    value.marker_name ||
    value.display_name ||
    value.test_name ||
    value.testName ||
    value.analyte ||
    value.component ||
    value.label ||
    value.observation_name ||
    value.observationName ||
    null
}

function biomarkerValue(value) {
  if (!value || typeof value !== 'object') return null
  return value.value ??
    value.result ??
    value.numeric_value ??
    value.numericValue ??
    value.observation_value ??
    value.observationValue ??
    value.result_value ??
    value.resultValue ??
    value.value_string ??
    value.valueString ??
    null
}

function flattenResultItems(value) {
  if (!value) return []
  if (Array.isArray(value)) return value.flatMap(flattenResultItems)
  if (typeof value !== 'object') return [value]
  return [
    value,
    ...flattenResultItems(value.biomarkers),
    ...flattenResultItems(value.markers),
    ...flattenResultItems(value.results),
    ...flattenResultItems(value.observations),
    ...flattenResultItems(value.components),
    ...flattenResultItems(value.values),
    ...flattenResultItems(value.items),
  ]
}

export function labBiomarkerItems(lab = {}) {
  const fields = [
    lab.biomarkers,
    lab.markers,
    lab.lab_options,
    lab.labOptions,
    lab.metadata?.biomarkers,
    lab.metadata?.markers,
    lab.metadata?.parsed_biomarkers,
    lab.metadata?.parsedBiomarkers,
    lab.results,
    lab.observations,
    lab.lab_results,
  ]
  return fields.flatMap(flattenResultItems)
}

function numericValue(value) {
  if (typeof value === 'number' && Number.isFinite(value)) return value
  const match = String(value ?? '').replace(/,/g, '').match(/-?\d+(?:\.\d+)?/)
  if (!match) return null
  const numeric = Number(match[0])
  return Number.isFinite(numeric) ? numeric : null
}

function firstNumeric(raw = {}, keys = []) {
  for (const key of keys) {
    const value = key.split('.').reduce((acc, part) => acc?.[part], raw)
    const numeric = numericValue(value)
    if (numeric !== null) return numeric
  }
  return null
}

function parseRangeText(raw = {}) {
  const text = String(
    raw.reference_range ||
    raw.referenceRange ||
    raw.normal_range ||
    raw.normalRange ||
    raw.range ||
    raw.ref_range ||
    raw.refRange ||
    '',
  ).trim()
  if (!text) return {}
  const normalized = text.replace(/,/g, '')
  const between = normalized.match(/(-?\d+(?:\.\d+)?)\s*(?:-|to)\s*(-?\d+(?:\.\d+)?)/i)
  if (between) return { low: Number(between[1]), high: Number(between[2]), label: text }
  const lessThan = normalized.match(/[<]\s*(-?\d+(?:\.\d+)?)/)
  if (lessThan) return { high: Number(lessThan[1]), label: text }
  const greaterThan = normalized.match(/[>]\s*(-?\d+(?:\.\d+)?)/)
  if (greaterThan) return { low: Number(greaterThan[1]), label: text }
  return { label: text }
}

function referenceRange(raw = {}) {
  const parsed = parseRangeText(raw)
  const low = firstNumeric(raw, [
    'reference_low',
    'referenceLow',
    'normal_low',
    'normalLow',
    'range_low',
    'rangeLow',
    'low',
    'min',
  ])
  const high = firstNumeric(raw, [
    'reference_high',
    'referenceHigh',
    'normal_high',
    'normalHigh',
    'range_high',
    'rangeHigh',
    'high',
    'max',
  ])
  return {
    low: low ?? parsed.low ?? null,
    high: high ?? parsed.high ?? null,
    label: parsed.label || raw.reference_range || raw.referenceRange || raw.normal_range || raw.normalRange || '',
  }
}

function explicitOptimalRange(raw = {}) {
  const low = firstNumeric(raw, ['optimal_low', 'optimalLow', 'optimized_low', 'optimizedLow'])
  const high = firstNumeric(raw, ['optimal_high', 'optimalHigh', 'optimized_high', 'optimizedHigh'])
  return { low, high }
}

function namedRangeFromRules(name, rules = []) {
  const normalizedName = normalizeBiomarkerName(name)
  return rules.find(rule =>
    (rule.aliases || []).map(normalizeBiomarkerName).some(alias =>
      normalizedName === alias || normalizedName.includes(alias) || alias.includes(normalizedName)
    )
  ) || null
}

function isNeutrophilResult(result = {}) {
  const normalized = normalizeBiomarkerName(result.name)
  return normalized === 'neutrophils' ||
    normalized.includes('neutrophils') ||
    normalized.includes('absolute neutrophils')
}

function isLikelyPercentResult(result = {}) {
  const unit = String(result.unit || '').toLowerCase()
  return unit.includes('%') || Number(result.numericValue) > 20
}

function namedOptimalRange(result = {}) {
  if (isNeutrophilResult(result)) {
    return isLikelyPercentResult(result)
      ? { min: 45, max: 62 }
      : { min: 2, max: 5.5 }
  }
  return namedRangeFromRules(result.name, OPTIMAL_RANGE_RULES)
}

function namedStatusRange(result = {}) {
  if (isNeutrophilResult(result)) {
    return isLikelyPercentResult(result)
      ? { min: 40, max: 75 }
      : { min: 1.5, max: 7.8 }
  }
  return namedRangeFromRules(result.name, STATUS_RANGE_RULES)
}

function resultLabKey(lab = {}, index = 0) {
  return String(
    lab.id ||
    lab.uuid ||
    lab.path ||
    lab.document?.id ||
    lab.pdf_document?.id ||
    lab.metadata?.id ||
    lab.metadata?.path ||
    `${labTitle(lab)}-${labReferenceDate(lab) || 'undated'}-${index}`,
  )
}

function rangeDisplayLabel(range = {}) {
  if (range.label) return range.label
  if (range.low != null && range.high != null) return `${range.low}-${range.high}`
  if (range.low != null) return `>${range.low}`
  if (range.high != null) return `<${range.high}`
  return ''
}

export function biomarkerOptimalRange(result = {}) {
  const explicit = result.optimalRange || {}
  const known = namedOptimalRange(result) || {}
  const low = explicit.low ?? known.min ?? null
  const high = explicit.high ?? known.max ?? null
  const label = rangeDisplayLabel({ low, high })
  return { low, high, label }
}

function biomarkerStatusRange(result = {}) {
  const parsed = result.range || {}
  const known = namedStatusRange(result) || {}
  return {
    low: parsed.low ?? known.min ?? null,
    high: parsed.high ?? known.max ?? null,
    label: rangeDisplayLabel({
      low: parsed.low ?? known.min ?? null,
      high: parsed.high ?? known.max ?? null,
      label: parsed.label,
    }),
  }
}

function statusText(raw = {}) {
  return String(
    raw.status ||
    raw.status_flag ||
    raw.statusFlag ||
    raw.flag ||
    raw.abnormal_flag ||
    raw.abnormalFlag ||
    raw.interpretation ||
    '',
  ).toLowerCase()
}

export function normalizeBiomarkerResult(raw, sourceLab = {}) {
  const name = biomarkerName(raw)
  const normalized = normalizeBiomarkerName(name)
  if (!normalized || isLabReportSectionHeading(name)) return null
  const value = biomarkerValue(raw)
  const numeric = numericValue(value)
  return {
    key: normalized,
    name,
    value,
    numericValue: numeric,
    unit: raw?.unit || raw?.units || raw?.unit_name || raw?.unitName || '',
    range: referenceRange(raw),
    optimalRange: explicitOptimalRange(raw),
    source: labTitle(sourceLab),
    date: labReferenceDate(sourceLab),
    statusText: statusText(raw),
    raw,
  }
}

export function evaluateBiomarkerStatus(result) {
  if (!result) return { level: 'empty', label: 'No value', color: 'default' }
  const text = result.statusText || ''
  if (/critical|panic|abnormal|out|high|low|above|below|\b[hl]\b/.test(text)) {
    const label = /low|below|\bl\b/.test(text) ? 'Low' : /high|above|\bh\b/.test(text) ? 'High' : 'Out of range'
    return { level: 'red', label, color: 'red' }
  }
  if (/optimal|optimized/.test(text)) return { level: 'green', label: 'Optimized', color: 'green' }
  if (/normal|within|in range/.test(text)) return { level: 'yellow', label: 'Normal', color: 'yellow' }

  const value = result.numericValue
  if (value === null) return { level: 'neutral', label: 'Value found', color: 'default' }
  const range = biomarkerStatusRange(result)
  if (range.low !== null && value < range.low) return { level: 'red', label: 'Low', color: 'red' }
  if (range.high !== null && value > range.high) return { level: 'red', label: 'High', color: 'red' }

  const optimal = biomarkerOptimalRange(result)
  const optimalLow = optimal.low
  const optimalHigh = optimal.high
  const hasOptimal = optimalLow !== null || optimalHigh !== null
  const inOptimal = (!hasOptimal) ? false :
    (optimalLow === null || value >= optimalLow) && (optimalHigh === null || value <= optimalHigh)
  if (inOptimal) return { level: 'green', label: 'Optimized', color: 'green' }
  if (range.low !== null || range.high !== null || hasOptimal) return { level: 'yellow', label: 'Normal', color: 'yellow' }
  return { level: 'neutral', label: 'No range', color: 'default' }
}

export function buildLabBiomarkerResults(labs = [], { requireValue = true, recentDays = null } = {}) {
  const cutoff = Number.isFinite(recentDays) ? Date.now() - (recentDays * DAY_MS) : null
  const seen = new Set()
  const results = []

  ;(labs || []).forEach((lab, labIndex) => {
    const labKey = resultLabKey(lab, labIndex)
    labBiomarkerItems(lab).forEach(item => {
      const normalized = normalizeBiomarkerResult(item, lab)
      if (!normalized) return
      const result = {
        ...normalized,
        labKey,
        labIndex,
        sourceLabel: labTitle(lab),
      }
      if (requireValue && (result.value === null || result.value === undefined || String(result.value).trim() === '')) return
      if (cutoff) {
        const date = parseLocalDate(result.date)
        if (!date || date.getTime() < cutoff) return
      }

      const duplicateKey = [
        labKey,
        result.key,
        String(result.value ?? '').trim(),
        String(result.unit || '').trim(),
        String(result.range?.label || '').trim(),
      ].join('|')
      if (seen.has(duplicateKey)) return
      seen.add(duplicateKey)
      results.push(result)
    })
  })

  return results
}

function preferredBiomarkerResult(current, candidate) {
  if (!current) return candidate
  const currentRange = current.range?.label || current.range?.low != null || current.range?.high != null
  const candidateRange = candidate.range?.label || candidate.range?.low != null || candidate.range?.high != null
  if (!currentRange && candidateRange) return candidate
  if (!current.unit && candidate.unit) return candidate
  return current
}

export function buildLabBiomarkerMatrix(labs = []) {
  const results = buildLabBiomarkerResults(labs, { requireValue: true })
  const columnsByKey = new Map()
  const rowsByKey = new Map()

  results.forEach(result => {
    const columnKey = result.labKey || result.date || 'undated'
    if (!columnsByKey.has(columnKey)) {
      columnsByKey.set(columnKey, {
        key: columnKey,
        date: result.date,
        label: result.date ? formatLabDate(result.date) : 'No date',
        source: result.sourceLabel || result.source || 'Lab report',
        sourceLabel: result.sourceLabel || result.source || 'Lab report',
        labIndex: result.labIndex ?? 0,
      })
    }
    if (!rowsByKey.has(result.key)) {
      const meta = biomarkerRowMeta(result.key, result.name)
      rowsByKey.set(result.key, {
        key: result.key,
        name: meta.name || result.name,
        section: meta.section,
        sectionLabel: meta.sectionLabel,
        sectionOrder: meta.sectionOrder,
        sortOrder: meta.sortOrder,
        resultsByDate: {},
      })
    }
    const row = rowsByKey.get(result.key)
    row.resultsByDate[columnKey] = preferredBiomarkerResult(row.resultsByDate[columnKey], result)
  })

  return {
    dates: [...columnsByKey.values()].sort((a, b) => {
      const dateDelta = (Date.parse(b.date) || 0) - (Date.parse(a.date) || 0)
      return dateDelta || (a.labIndex ?? 0) - (b.labIndex ?? 0)
    }),
    rows: [...rowsByKey.values()].sort((a, b) =>
      (a.sectionOrder ?? 1) - (b.sectionOrder ?? 1) ||
      (a.sortOrder ?? Number.MAX_SAFE_INTEGER) - (b.sortOrder ?? Number.MAX_SAFE_INTEGER) ||
      a.name.localeCompare(b.name)
    ),
  }
}

export function findMatchingBiomarker(results = [], marker = {}) {
  const aliases = (marker.aliases || [marker.label]).map(normalizeBiomarkerName).filter(Boolean)
  return results.find(result => aliases.some(alias =>
    result.key === alias || result.key.includes(alias) || alias.includes(result.key)
  )) || null
}

export function buildRecentLabCoverage(labs = [], requiredMarkers = HRT_REQUIRED_BIOMARKERS, { recentDays = 90 } = {}) {
  const results = buildLabBiomarkerResults(labs, { requireValue: true, recentDays })
  const found = []
  const missing = []

  requiredMarkers.forEach(marker => {
    const result = findMatchingBiomarker(results, marker)
    if (result) {
      found.push({
        label: marker.label,
        value: result.value,
        unit: result.unit,
        date: result.date,
        source: result.source,
        status: evaluateBiomarkerStatus(result),
      })
    } else {
      missing.push(marker.label)
    }
  })

  return {
    complete: missing.length === 0 && requiredMarkers.length > 0,
    found,
    missing,
    required: requiredMarkers.map(marker => marker.label),
    recentDays,
  }
}

export function ageFromDateOfBirth(dateOfBirth) {
  const dob = parseLocalDate(dateOfBirth)
  if (!dob) return null
  const today = new Date()
  let age = today.getFullYear() - dob.getFullYear()
  const monthDelta = today.getMonth() - dob.getMonth()
  if (monthDelta < 0 || (monthDelta === 0 && today.getDate() < dob.getDate())) age -= 1
  return Number.isFinite(age) ? age : null
}

export function hrtRequiredBiomarkersForPatient(patient = {}) {
  const age = ageFromDateOfBirth(patient?.date_of_birth || patient?.dateOfBirth || patient?.dob)
  return age !== null && age >= 40
    ? [...HRT_REQUIRED_BIOMARKERS, HRT_PSA_BIOMARKER]
    : HRT_REQUIRED_BIOMARKERS
}

export function formatLabDate(value) {
  const date = parseLocalDate(value)
  if (!date) return ''
  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })
}
